import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '~/Locale';
import { formatMoney } from '~/helpers/currency';
import FinanceMonthlyCost from '~/App/shared/components/FinanceCalculator/FinanceMonthlyCost';
import {
  MONTHLY_COST_MONTHS,
  MONTHLY_COST_RESIDUAL_VALUE_MONTHS
} from '~/config/constants';

const FinancingInformation = styled.div`
  font-size: 1rem;
  color: ${props => props.theme.colors.text.dark};
`;

const FinancingInformationContent = styled.span`
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;
  align-items: center;
`;

const FinanceMonthlyCostValue = styled.span`
  white-space: nowrap;
`;

interface Props {
  auctionCost: number;
  withResidualValue: boolean;
  showLoanInformation: boolean;
}
const AlternativePaymentInformation = ({
  auctionCost,
  showLoanInformation,
  withResidualValue
}: Props) => {
  const { t } = useTranslation();

  return (
    <FinancingInformation>
      {showLoanInformation && (
        <FinancingInformationContent>
          <span>{t('Monthly cost from')}</span>
          <FinanceMonthlyCost
            price={auctionCost}
            withResidualValue={withResidualValue}
            months={
              withResidualValue
                ? MONTHLY_COST_RESIDUAL_VALUE_MONTHS
                : MONTHLY_COST_MONTHS
            }
          >
            {({ value }) => (
              <FinanceMonthlyCostValue>
                {formatMoney({
                  value,
                  currency: t('SEK / month')
                })}
              </FinanceMonthlyCostValue>
            )}
          </FinanceMonthlyCost>
        </FinancingInformationContent>
      )}
    </FinancingInformation>
  );
};

export default AlternativePaymentInformation;
